import { usePathname } from 'next/navigation'

import { PasskeyConfirmationDialog } from '~/components/component-library/Dialog/PasskeyConfirmationDialog'
import { useAuth } from '~/context/AuthProvider'
import { useHasPendingMerkleTransactionsForSmartAccountId } from '~/hooks/merkle-transactions/usePendingMerkleTransactions'
import { useArchiveSmartAccount } from '~/hooks/smart-accounts/useArchiveSmartAccount'
import { useNavigation } from '~/hooks/useNavigation'
import { OrgSmartAccount } from '~/types'

export const ArchiveAccountDialog = ({
  smartAccount,
}: {
  smartAccount: OrgSmartAccount
}) => {
  const navigate = useNavigation()
  const pathname = usePathname()
  const {
    addressSearchHistory: { removeFromSearchHistory },
  } = useAuth()
  // Table opens this on a cold cache — block confirm until the check resolves
  const { hasPendingTransactions, isLoading: isCheckingPending } =
    useHasPendingMerkleTransactionsForSmartAccountId(smartAccount.id)
  const { archiveSmartAccount } = useArchiveSmartAccount(smartAccount)

  const handleConfirmed = async () => {
    await archiveSmartAccount({
      onSuccess: () => {
        removeFromSearchHistory(smartAccount.address)
        // Navigate away only from the archived account's own page
        if (
          pathname
            ?.toLowerCase()
            .startsWith(`/accounts/${smartAccount.address}`.toLowerCase())
        ) {
          navigate('/')
        }
      },
    })
  }

  return (
    <PasskeyConfirmationDialog
      id="removeSmartAccountConfirmation"
      title={`Archive "${smartAccount.name}"?`}
      confirmText="Archive"
      confirmDisabled={hasPendingTransactions || isCheckingPending}
      confirmDisabledReason={
        hasPendingTransactions
          ? 'Cannot remove smart account while there are pending transactions'
          : isCheckingPending
            ? 'Checking for pending transactions...'
            : undefined
      }
      onConfirmed={handleConfirmed}
    />
  )
}
